export default {"src":"/_next/static/media/license-plate.6524928a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};